/* Native details work without JavaScript. Enhancement animates height and keeps
   keyboard semantics and Theme Editor block selection in sync. */
if (!customElements.get('mm-accordion')) {
  customElements.define('mm-accordion', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelectorAll('details').forEach((details) => {
        const summary = details.querySelector('summary');
        summary.setAttribute('role', 'button');
        summary.setAttribute('aria-expanded', String(details.open));
        details.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(details.open));
        });
        summary.addEventListener('click', (event) => {
          if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          event.preventDefault();
          const wasOpen = details.dataset.expanding
            ? details.dataset.expanding === 'true'
            : details.open;
          const start = details.getBoundingClientRect().height;
          if (details.mmAnimation) details.mmAnimation.cancel();
          const opening = !wasOpen;
          details.dataset.expanding = String(opening);
          details.open = true;
          details.style.overflow = 'hidden';
          const end = opening ? details.scrollHeight : summary.getBoundingClientRect().height;
          summary.setAttribute('aria-expanded', String(opening));
          details.mmAnimation = details.animate(
            { height: [`${start}px`, `${end}px`] },
            { duration: 220, easing: 'ease-out' }
          );
          details.mmAnimation.onfinish = () => {
            details.open = opening;
            details.style.overflow = '';
            delete details.dataset.expanding;
            details.mmAnimation = null;
          };
        });
      });
    }
  });
  document.addEventListener('shopify:block:select', (event) => {
    const details = event.target.closest('mm-accordion details');
    if (!details) return;
    if (details.mmAnimation) details.mmAnimation.cancel();
    details.style.overflow = '';
    delete details.dataset.expanding;
    details.open = true;
  });
}

// Appio clips slides inside its Swiper viewport. Keep its initialized controls
// (and their existing event handlers) outside that viewport, beside the cards.
function positionMiniMatchReviewArrows(root = document) {
  root.querySelectorAll('.mm-reviews--app').forEach((section) => {
    if (section.mmArrowObserver) return;
    const position = () => {
      section.querySelectorAll('.agrs__body').forEach((body) => {
        if (!body.swiper || body.swiper.destroyed) return;
        const wrapper = body.closest('.agrs__body-wrapper');
        if (!wrapper) return;
        body.querySelectorAll(':scope > .agrs__swiper-button-prev, :scope > .agrs__swiper-button-next').forEach((arrow) => {
          wrapper.querySelectorAll(`:scope > .${arrow.classList.contains('agrs__swiper-button-prev') ? 'agrs__swiper-button-prev' : 'agrs__swiper-button-next'}`).forEach((old) => old.remove());
          wrapper.append(arrow);
        });
      });
    };
    section.mmArrowObserver = new MutationObserver(position);
    section.mmArrowObserver.observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    position();
  });
}
positionMiniMatchReviewArrows();
document.addEventListener('shopify:section:load', (event) => positionMiniMatchReviewArrows(event.target));
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('.mm-reviews--app').forEach((section) => section.mmArrowObserver?.disconnect());
});
